(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 9117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);


// interface AppContainerProps {
//   children: React.ReactNode;
// }
var AppContainer = function AppContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
    className: "flex min-h-screen items-center justify-center bg-[var(--bg-color)]",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className: "flex min-h-screen w-screen max-w-[var(--max-width)] flex-col items-center justify-center bg-[var(--app-bg-color)]",
      children: children
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AppContainer);

/***/ }),

/***/ 6547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_AppContainer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9117);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(214);
/* harmony import */ var _styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);





var NotFound = function NotFound() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_AppContainer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      src: "/404.png",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().title404),
      alt: "404 image"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundMessage),
      children: ["The page you are looking for does not exist. ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}), " Sorry :("]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
      href: "/",
      className: (_styles_Home_module_css__WEBPACK_IMPORTED_MODULE_2___default().notFoundHeadHome),
      children: "Head home"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);
/*
  import Link from "next/link";

const NotFound = () => (
  <div className="flex min-h-screen items-center justify-center bg-[var(--bg-color)]">
    <div className="flex h-screen w-screen max-w-[var(--max-width)] flex-col items-center justify-center bg-[var(--app-bg-color)]">
      <img
        src="/illustrations/404-Error-illustration.svg"
        alt="404 image"
        height="250px"
        width="250px"
        className="object-cover"
      />

      <p className="mt-8 max-w-sm text-center text-xl">
        Oops! We couldn't find that page. <br />
        Let's get you back on track.
      </p>

      <Link href="/" prefetch={true}>
        <a className="mt-8 rounded-lg bg-primary px-6 py-4 text-xl">Head home</a>
      </Link>

      <footer className="fixed bottom-10 left-1/2 -translate-x-1/2 transform text-center">
        <small className="opacity-70">
          Illustrations by{" "}
          <a href="https://storyset.com/web" target="_blank" rel="noopener noreferrer">
            Storyset
          </a>
        </small>
      </footer>
    </div>
  </div>
);

export default NotFound;

*/

/***/ }),

/***/ 394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(6547);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 214:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__bCOhY","cart":"Home_cart__LyzTg","about":"Home_about__6Y_1_","profilePic":"Home_profilePic__7nemD","footerTagline":"Home_footerTagline__wH1if","notFound":"Home_notFound___6xAl","notFoundMessage":"Home_notFoundMessage__KeTwU","notFoundHeadHome":"Home_notFoundHeadHome__0_jo1","link":"Home_link__mt0ji","title404":"Home_title404__7ZWAE"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);